import React from "react";
import styles from "./CienieKsiazka.css";
import cienieOrleanuImg from "../../../assets/ciienieNowegoOrleanu.png";
import spacer from "../../../assets/spacer.png";
import CallToActionBtn from "../../CallToActionBtn/CallToActionBtn";

const text = {
  subtitle:
    "LATA 20.. XX WIEKU. ZAUŁKI NOWEGO ORLEANU TĘTNIĄ JAZZEM I SPŁYWAJĄ PRZEMYCANYM ALKOHOLEM, ALE NA BAGNACH CORAZ WYRAŹNIEJ SŁYCHAĆ SZEPT DEMONÓW... STRZEŻCIE SIĘ ŚPIĄCEGO, WY, KTÓRZY SIĘGACIE PO TĘ KSIĄŻKĘ!",
  desc1:
    "Choć John R. Legrasse jest starym policyjnym wygą, ta jedna sprawa od dawna nie daje mu spokoju. Luizjańskie bagna i makabryczny ofiarny krąg do dziś prześladują go w koszmarach. Stary Castro i jego sekta. Sądził, że wyłapali wtedy wszystkich. Ale gdy w kryjówce przemytników policjant znajduje okaleczone kobiece ciało, wie, że wyznawcy demonów powrócili do Nowego Orleanu. Legrasse nie wierzy w czarną magię – chce jedynie dorwać bydlaków, którzy dla własnej przyjemności katują kobiety.",
  desc2:
    " W tym mieście, przesiąkniętym voodoo i okultyzmem, trudno jednak pozostać sceptykiem. Wkrótce i jemu obecność pradawnych bóstw wyda się tak realna jak nigdy przedtem... To intrygująca mieszanka horroru i kryminału – nie tylko dla fanów Lovecrafta!",
desc3: "PREMIERA: 27 lutego 2019 r."
};

const CienieKsiazka = props => (
  <div className={styles.mainDiv}>
    <img
      src={cienieOrleanuImg}
      className={styles.mainImg}
      alt="Cienie Orleanu"
    />
    <p className={styles.subtitle}>{text["subtitle"]}</p>
    <img src={spacer} className={styles.spacer} alt="spacer" />
    <p className={styles.text}>{text["desc1"]}</p>
    <img src={spacer} className={styles.spacer} alt="spacer" />
    <p className={styles.text}>{text["desc2"]}</p>
    <img src={spacer} className={styles.spacer} alt="spacer" />
    <p className={styles.subtitle}>{text["desc3"]}</p>
    <img src={spacer} className={styles.spacer} alt="spacer" />
    <CallToActionBtn cienie/>
  </div>
);

export default CienieKsiazka;



// WEBPACK FOOTER //
// ./src/components/Mobile/CienieKsiazka/CienieKsiazka.js